import { resolveDynamicComponent as _resolveDynamicComponent, openBlock as _openBlock, createBlock as _createBlock, KeepAlive as _KeepAlive, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode, resolveComponent as _resolveComponent } from "vue";
import { useUserStore } from "@/stores/user";

import { useRoute } from 'vue-router';
import { storeToRefs } from 'pinia';
import { watch } from 'vue';
export default {
  __name: 'App',
  setup(__props) {
    const route = useRoute();
    const {
      referrerIsVrf
    } = storeToRefs(useUserStore());
    watch(() => route.query, v => {
      if (!['/', '/preload'].includes(route.path)) {
        return;
      }
      const {
        ref
      } = v;
      if (!ref || ref !== 'vrf') {
        referrerIsVrf.value = false;
      } else {
        referrerIsVrf.value = true;
      }
    }, {
      immediate: true,
      deep: true
    });
    return (_ctx, _cache) => {
      const _component_router_view = _resolveComponent("router-view");
      return _openBlock(), _createBlock(_component_router_view, null, {
        default: _withCtx(({
          Component
        }) => [_createVNode(_Transition, {
          name: "fade",
          mode: "out-in"
        }, {
          default: _withCtx(() => [(_openBlock(), _createBlock(_KeepAlive, null, [(_openBlock(), _createBlock(_resolveDynamicComponent(Component)))], 1024))]),
          _: 2
        }, 1024)]),
        _: 1
      });
    };
  }
};